import React, { useState } from "react";
import CounterBeds_Guest from "../Host/CreateListing/counterBeds_Guest";
import Room_Beds_counter from "../../Components/common/Room_Beds_counter";
import SwitchExample from "../../Components/common/switch";
import Button from "../../Components/common/Button";
import RangeSlider from "../../Components/common/rangeSlider";
import RangeSlider2 from "../../Components/common/rangeSlider2";
import Slider from "react-slider";
import { useEffect } from "react";
import AddToCart from "../../Components/common/addCarts";
import { apiPublicUser, formatIndianRupeesFunc } from "../../utils/constant";
import axios from "axios";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { amenitiesFilter, bathroomsFilter, bedroomsFilter, bedsFilter, maxFilter, minFilter, propertyFilter, spaceFilter } from "../../utils/redux/FilterSlicer";
import CardWrapper from "../../Components/common/cardWrapper";
import { useLocation } from "react-router-dom";
import PropTypes from 'prop-types';
import { setFilterParams } from "../../utils/redux/ParamsSlicer";


const UserFilterPopup = (props) => {

  const ui = {
    container: { maxWidth: 880, margin: '0 auto', padding: '16px 16px 96px 16px' },
    section: { marginTop: 20, marginBottom: 14 },
    sectionHeader: { fontSize: 18, fontWeight: 700, margin: '0 0 8px 0' },
    subtext: { margin: '4px 0 12px 0', color: '#6b7280', fontSize: 13 },
    card: { border: '1px solid #e5e7eb', borderRadius: 12, padding: 16, background: '#fff', boxShadow: '0 6px 20px rgba(0,0,0,.06)' },
    values: { fontWeight: 600, marginBottom: 8 },
    priceInputs: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginTop: 12 },
    inputContainer: { display: 'flex', flexDirection: 'column', gap: 6 },
    inputLabel: { fontSize: 13, color: '#374151', marginBottom: 4 },
    inputInner: { display: 'flex', alignItems: 'center', border: '1px solid #e5e7eb', borderRadius: 10, padding: '8px 10px', background: '#fff' },
    inputSymbol: { marginRight: 6, color: '#6b7280' },
    inputField: { border: 'none', outline: 'none', width: '100%', fontSize: 14 },
    grid3: { display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 16 },
    checkboxLabel: { display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer', padding: '8px 10px', border: '1px solid #e5e7eb', borderRadius: 10, background: '#fff' },
    checkboxInput: { transform: 'scale(1.1)' },
    labelText: { fontSize: 14 },
    helpText: { margin: '6px 0 10px 34px', fontSize: 12, color: '#6b7280' },
    row: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', border: '1px solid #e5e7eb', borderRadius: 12, padding: '10px 12px', marginBottom: 10 },
    rowLabel: { fontSize: 14, fontWeight: 600 },
    gridAuto: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))', gap: 12 },
    amenCat: { marginTop: 12, paddingTop: 8, borderTop: '1px solid #f1f5f9' },
    amenTitle: { fontSize: 15, fontWeight: 600, margin: '0 0 8px 0' },
    amenList: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: 8 },
    amenLabel: { display: 'flex', alignItems: 'center', gap: 10, padding: '8px 10px', border: '1px solid #e5e7eb', borderRadius: 10, background: '#fff', cursor: 'pointer' },
    amenInput: { transform: 'scale(1.05)' },
    amenText: { fontSize: 14, margin: 0 },
    bottomBar: { position: 'fixed', left: 0, right: 0, bottom: 0, background: '#fff', padding: '12px 16px', display: 'flex', gap: 12, justifyContent: 'space-between', alignItems: 'center', boxShadow: '0 -6px 20px rgba(0,0,0,.06)', borderTop: '1px solid #e5e7eb' },
    clearBtn: { padding: '10px 14px', borderRadius: 10, border: '1px solid #e5e7eb', background: '#fff', cursor: 'pointer', fontWeight: 600 },
    applyBtnWrap: { marginLeft: 'auto' }
  };


  const location = useLocation()



  console.log('Longtext')
  
  // const [allFilters ,setAllFilters] = useState()

  const storeSel = useSelector((state) => state);

  // const location = useLocation()
  const queryParams = new URLSearchParams(window.location.search);


  /// for space type  fetching from params
  const initialSpaceTypes = queryParams.get("space_type")
  ? queryParams.get("space_type").split(",")
  : [];





// State for selected space types
const [selectedSpaceTypes, setSelectedSpaceTypes] = useState(
  initialSpaceTypes
);
 // Function to handle checkbox change
//  const handleCheckboxChangeSpace = (spaceType) => {
//   setSelectedSpaceTypes((prevSelected) => {
//     if (prevSelected.includes(spaceType)) {
//       return prevSelected.filter((type) => type !== spaceType);
//     } else {
//       return [...prevSelected, spaceType];
//     }
//   });
// };

const handleCheckboxChangeSpace = (spaceType) => {
  setSelectedSpaceTypes((prevSelected) => {
    const updatedSpaceTypes = prevSelected.includes(spaceType)
      ? prevSelected.filter((type) => type !== spaceType)
      : [...prevSelected, spaceType];
    return updatedSpaceTypes;
  });
};


///////////Amenties filter------------------------------------
const parseQueryParamArray = (key) => {
  const paramValue = queryParams.get(key);
  return paramValue ? paramValue.split(",").map(item => parseInt(item, 10)) : [];
};

const initialAmenitiesTypes = parseQueryParamArray("amenities");

const [selectedAmenities, setSelectedAmenities] = useState(initialAmenitiesTypes);

const handleCheckboxChange = (amenityId) => {
  setSelectedAmenities((prevSelected) => {
    if (prevSelected.includes(amenityId)) {
      return prevSelected.filter((id) => id !== amenityId);
    } else {
      return [...prevSelected, amenityId];
    }
  });
};


///---------------------------------------------------------------------------------

console.log(selectedAmenities,initialAmenitiesTypes,'checkSelectedValues')
  

  const bedsCount = storeSel.filterDataSlice?.bedsCount;
  const bathroomsCount = storeSel.filterDataSlice?.bathroomsCount;
  const bedroomsCount = storeSel.filterDataSlice?.bedroomsCount;
 
  const filterdata = storeSel.filterDataSlice.filterData;
  const bedsMax = filterdata?.max_bed_bedroom_bathroom[0]?.max_beds
  const bedroomsMax = filterdata?.max_bed_bedroom_bathroom[0]?.max_bedrooms
  const bathroomsMax = filterdata?.max_bed_bedroom_bathroom[0]?.max_bathroo



  ///Price slider filter states--------------------

  
  const minGet = filterdata?.room_prices[0].min_price
  const maxGet = filterdata?.room_prices[0].max_price

  const minPriceCount = queryParams.get("base_price")
  ? queryParams.get("base_price")
  : minGet;
  const maxPriceCount = queryParams.get("ceil_price")
  ? queryParams.get("ceil_price")
  : maxGet;


  
  const [min, setMin] = useState(minGet);
  const [max, setMax] = useState(maxGet);
  const [values, setValues] = useState([ minPriceCount? minPriceCount : minGet, maxPriceCount? maxPriceCount : maxGet]);

  

  const handleMinChange = (event) => {
    const newMin = parseInt(event.target.value.replace(/\D/g, ""), 10);
    if (!isNaN(newMin) && newMin <= max) {
      setValues([newMin, values[1]]);
    }
  };
  console.log(values,'iio')

  const handleMaxChange = (event) => {
    const newMax = parseInt(event.target.value.replace(/\D/g, ""), 10);
    if (!isNaN(newMax) && newMax >= min) {
      setValues([values[0], newMax]);
    }
  };

  const handleSliderChange = (newValues) => {
    setValues(newValues);
  };


  // const minPriceCount = storeSel.filterDataSlice?.minPriceCount
  // const maxPriceCount = storeSel.filterDataSlice?.maxPriceCount






  console.log(filterdata,'hhjj')

  //rooms and beds filter -----------------------------------------
  const initialBedroomsTypes = queryParams.get("bedrooms")
  ? queryParams.get("bedrooms")
  : 1;
  const initialBedsTypes = queryParams.get("beds")
  ? queryParams.get("beds")
  : 1;

  const initialBathroomsTypes = queryParams.get("bathrooms")
  ? queryParams.get("bathrooms")
  : 1;



  const [count1, setCount1] = useState( initialBedroomsTypes || 1)
  const [count2, setCount2] = useState(initialBathroomsTypes || 1)

  const [count3, setCount3] = useState(initialBedsTypes || 1)

  
  const dispatch = useDispatch()

  const handleCountChange1 = (newCount) => {
    setCount1(newCount); 
  };
  
  const handleCountChange2 = (newCount) => {
    setCount2(newCount); 
  };
  
  const handleCountChange3 = (newCount) => {
    setCount3(newCount); 
    
  };

  console.log('checkType')
  /////////--------------------------------------------------------


  const clearFilters = () => {
    // Clear all selected filter states
    setSelectedAmenities([]);
    setSelectedSpaceTypes([]);
    setSelectedPropeUids([]);
    setValues([minGet, maxGet]);
    setCount1(1);
    setCount2(1);
    setCount3(1);

   
  };



 


// proerty typw card type----------------------------------------------------------------------------------------
const propertTypeData = filterdata?.propertyType;
const initialSelectedProperty = storeSel.filterDataSlice?.propertyTypeCount;

// const initialPropertyTypes = queryParams.get("property_type")
//   ? queryParams.get("property_type")
//   : [];

const [selectedPropIndex, setSelectedPropIndex] = useState(null);

  const [selectedPropUids, setSelectedPropeUids] = useState([]);
  
  console.log(selectedPropIndex,selectedPropUids,'ooj')

  // const isCardSelected = (uid) => selectedPropUids.includes(uid);
  const isCardSelected = (uid) => selectedPropUids.some(selectedUid => String(selectedUid) === String(uid));




  // const handleCardClick = (index) => {

  //   const selectedPropUid = propertTypeData[index].id;  

  //   if (isCardSelected(selectedPropUid)) {
      
  //     setSelectedPropeUids((prevSelectedUids) =>
  //       prevSelectedUids.filter((id) => id !== selectedPropUid)
  //     );
  //   } else {
      
  //     setSelectedPropeUids((prevSelectedUids) => [
  //       ...prevSelectedUids,
  //       selectedPropUid,
  //     ]);
  //   }
  // };

  
const handleCardClick = (index) => {
  const selectedPlaceUid = String(propertTypeData[index].id);

  console.log(selectedPlaceUid,'checkOnceAll')


  setSelectedPropeUids((prevSelectedUids) => {
    const isAlreadySelected = prevSelectedUids.includes(selectedPlaceUid);
    console.log(isAlreadySelected,'checkOnceAll')
    let updatedSelectedUids;

    if (isAlreadySelected) {
      // Unselect the card
      updatedSelectedUids = prevSelectedUids.filter((id) => id !== selectedPlaceUid);
    } else {
      // Select the card
      updatedSelectedUids = [...prevSelectedUids, selectedPlaceUid];
    }

    console.log(updatedSelectedUids,'checkOnceAll')
    const queryParams = new URLSearchParams(window.location.search);
    if (updatedSelectedUids.length > 0) {
    console.log(updatedSelectedUids,'checkOnceAll')

      queryParams.set("property_type", updatedSelectedUids.join(","));
    } else {
      queryParams.delete("property_type");
    }

    return updatedSelectedUids;
  });
};




  useEffect(() => {
    const parseQueryParamsAndUpdateState = () => {
      const queryParams = new URLSearchParams(window.location.search);
      const placeTypesParam = queryParams.get('property_type');
  
      if (placeTypesParam) {
        const selectedPlaceUids = placeTypesParam.split(',');
        setSelectedPropeUids(selectedPlaceUids);
      } else {
        setSelectedPropeUids([]);
      }
    };
  
    parseQueryParamsAndUpdateState();
  }, [location.search, location]);







  console.log((selectedAmenities)); 
  //============================================================================

  // const saveSliderValuesToLocal = () => {
  //  dispatch(bedroomsFilter(count1))
  //  dispatch(bathroomsFilter(count2))
  //   dispatch(bedsFilter(count3))
  //   dispatch(amenitiesFilter(selectedAmenities));
  //   dispatch(minFilter(values[0]))
  //   dispatch(maxFilter(values[1]))
  //   dispatch(spaceFilter(selectedSpaceTypes));
  //   dispatch(propertyFilter(selectedPropUids))
  //   props.closeModal()
  // };
  console.log( values[1],values[0],'checkAllPropS')

  
  
  console.log(count1,'checkCount1')
  
   const saveFilterValuesToLocal = () => {

    console.log(selectedSpaceTypes,'checkSpacevalue')

  const queryParams = new URLSearchParams(window.location.search);

  

    if(values[1] !== maxGet || count1 >= 1 || count2 > 1 || count3 > 1 || values[0] !== minGet){
      queryParams.set("bedrooms", count1);

    }
    if(values[1] !== maxGet || count1 > 1 ||count2 >= 1 || count3 > 1 || values[0] !== minGet){
      queryParams.set("bathrooms", count2);
    }
    if(values[1] !== maxGet || count1 > 1 ||count2 > 1 || count3 >= 1 || values[0] !== minGet){
      queryParams.set("beds", count3);
    }

    if(values[1] !== minGet ){

      queryParams.set("base_price", values[0]);
    }
 
    if(values[0] !== maxGet){
      queryParams.set("ceil_price", values[1]);
    }

    if (selectedSpaceTypes.length > 0) {
      queryParams.set("space_type", selectedSpaceTypes.join(","));
    }else {
      queryParams.delete("space_type");
    }

    if (selectedPropUids.length > 0) {
      queryParams.set("property_type", selectedPropUids.join(","));
    } else {
      queryParams.delete("property_type");
    }

    
    // Check and append amenities if it has values
    if (selectedAmenities.length > 0) {
      queryParams.set("amenities", selectedAmenities.join(","));
    }else {
      queryParams.delete("amenities");
    }

    
  
    console.log(queryParams,'checkAllFilterParam')
  
    const queryString = queryParams.toString();
    dispatch(setFilterParams({ query: queryString }));
    // const newPath = queryString ? `${window.location.pathname}?${queryString}` : window.location.pathname;

    // console.log(newPath,'checkNewPath')
    // // window.history.pushState(null, "", newPath);
    // window.history.replaceState({}, "", newPath);
  
    props.closeModal();
  };

  


  

  console.log(typeof props.appendQueryParamFunc,'checkParamsType')
  console.log( props,'checkParamsType')



  

  
  return (
    <>
    <div className="user-filter-popup paddingCustom2AllSide" style={ui.container}>
      {/* Price Range Section */}
      <div style={ui.section}>
        <h3 className="slider-price-range-text" style={ui.sectionHeader}>Price Range</h3>
        <p className="start-para" style={ui.subtext}>The average total price of 2 nights is {props.nightPrice}</p>
        <div className="range-slider-new" style={ui.card}>
          <div className="values" style={ui.values}>₹{formatIndianRupeesFunc(values[0])} – ₹{formatIndianRupeesFunc(values[1])}</div>
          <Slider className="slider" onChange={handleSliderChange} value={values} min={minGet} max={maxGet} />
          <div className="price-input-box" style={ui.priceInputs}>
            <div className="input-container" style={ui.inputContainer}>
              <label htmlFor="minInput" style={ui.inputLabel}>Min Price</label>
              <div className="input-with-symbol" style={ui.inputInner}>
                <span style={ui.inputSymbol}>₹</span>
                <input type="number" id="minInput" value={values[0]} onChange={handleMinChange} style={ui.inputField} />
              </div>
            </div>
            <div className="input-container" style={ui.inputContainer}>
              <label htmlFor="maxInput" style={ui.inputLabel}>Max Price</label>
              <div className="input-with-symbol" style={ui.inputInner}>
                <span style={ui.inputSymbol}>₹</span>
                <input type="number" id="maxInput" value={values[1]} onChange={handleMaxChange} style={ui.inputField} />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Type of Space */}
      <h2 className="place-type-text" style={ui.sectionHeader}>Type of Space</h2>
      <div className="checbox-div" style={{...ui.grid3, marginBottom: 8}}>
        <div>
          <label style={ui.checkboxLabel}>
            <input
              className="largerCheckbox"
              style={ui.checkboxInput}
              type="checkbox"
              checked={selectedSpaceTypes.includes("Entire Place")}
              onChange={() => handleCheckboxChangeSpace("Entire Place")}
            />
            <span style={ui.labelText}>Entire Place</span>
          </label>
          <p className="checkbox-para" style={ui.helpText}>A Place all to Yourself</p>
        </div>
        <div>
          <label style={ui.checkboxLabel}>
            <input
              className="largerCheckbox"
              style={ui.checkboxInput}
              type="checkbox"
              checked={selectedSpaceTypes.includes("A Private Room")}
              onChange={() => handleCheckboxChangeSpace("A Private Room")}
            />
            <span style={ui.labelText}>A Private Room</span>
          </label>
          <p className="checkbox-para" style={ui.helpText}>
            Your Own room in home or hotel, plus some shared common place
          </p>
        </div>
        <div>
          <label style={ui.checkboxLabel}>
            <input
              className="largerCheckbox"
              style={ui.checkboxInput}
              type="checkbox"
              checked={selectedSpaceTypes.includes("A Shared Room")}
              onChange={() => handleCheckboxChangeSpace("A Shared Room")}
            />
            <span style={ui.labelText}>A Shared Room</span>
          </label>
          <p className="checkbox-para" style={ui.helpText}>
            A sleeping space and common areas that may be shared with others
          </p>
        </div>
      </div>

      {/* Rooms and Beds */}
      <h2 className="place-type-text" style={{...ui.sectionHeader, marginTop: 16}}>Rooms and Beds</h2>
      <div className="room-beds-cart-div" style={ui.row}>
        <span className="text" style={ui.rowLabel}>Bedrooms:</span>
        <AddToCart
          cartParent="cart-parent"
          cartBtn="cart-button"
          cartCount="cart-count"
          initialCount={count1}
          maxCount={bedroomsMax}
          onCountChange={handleCountChange1}
        />
      </div>
      <div className="room-beds-cart-div" style={ui.row}>
        <span className="text" style={ui.rowLabel}>Bathrooms:</span>
        <AddToCart
          cartParent="cart-parent"
          cartBtn="cart-button"
          cartCount="cart-count"
          initialCount={count2}
          maxCount={bathroomsMax}
          onCountChange={handleCountChange2}
        />
      </div>
      <div className="room-beds-cart-div" style={ui.row}>
        <span className="text" style={ui.rowLabel}>Beds:</span>
        <AddToCart
          cartParent="cart-parent"
          cartBtn="cart-button"
          cartCount="cart-count"
          initialCount={count3}
          maxCount={bedsMax}
          onCountChange={handleCountChange3}
        />
      </div>

      {/* Property Type */}
      <h2 className="place-type-text" style={ui.sectionHeader}>Property Type</h2>
      <div className="Property-type-filter-parent" style={ui.gridAuto}>
        {propertTypeData?.map((property,index)=>{
          return(
            <CardWrapper 
              wrapperClass={`property-type-icon-card ${isCardSelected(String(property.id)) ? "selected-card" : ""}`}
              onClick={() => {
                setSelectedPropIndex(index);
                handleCardClick(index);
              }}
            >
              <span>
                <img src={property.icon_url} alt="" />
              </span>
              <span className="icon-text">{property.name}</span>
            </CardWrapper>
          )
        })}
      </div>

      {/* Amenities */}
      <h2 className="place-type-text" style={ui.sectionHeader}>Amenities</h2>
      <div className="popup-container">
        {filterdata?.amenities_category
          ?.filter((category) => category.amenities_details.length > 0)
          .map((category) => (
            <div style={{...ui.amenCat}} key={category.id}>
              <h5 style={ui.amenTitle}>{category.category_type}</h5>
              <div className="amenties-list-box" style={ui.amenList}>
                {category.amenities_details.map((amenity) => (
                  <div className="amenities-list" key={amenity.id}>
                    <label style={ui.amenLabel}>
                      <input
                        type="checkbox"
                        style={ui.amenInput}
                        checked={selectedAmenities?.includes(amenity.id)}
                        onChange={() => handleCheckboxChange(amenity.id)}
                      />
                      <p style={ui.amenText}>{amenity.amenity_name}</p>
                    </label>
                  </div>
                ))}
              </div>
            </div>
          ))}
      </div>

      <h2 className="place-type-text">Top-tier stays</h2>
      <div className="host-tier-switchbox">
        <div className="host-tier-box">
          <h3>Super Host</h3>
          <p>Stay with recognised hosts</p>
        </div>
        <label>
          {/* <SwitchExample
            swicthClass="switch-class"
            onChange={handleChange}
            checked={checked}
          /> */}
        </label>
      </div>
    </div>
    <div className="clear_apply-btn-box btn fixed-bottom-btn" style={ui.bottomBar}>
      <div onClick={clearFilters} className="clear-btn" style={ui.clearBtn}>Clear</div>
      <div style={ui.applyBtnWrap}>
        <Button
          btnclasses="apply-btn"
          btnText="Apply"
          onClick={saveFilterValuesToLocal}
        />
      </div>
    </div>
    </>
  );
};
// UserFilterPopup.propTypes = {
//   queryParams: PropTypes.object.isRequired,
//   appendQueryParamFunc: PropTypes.func.isRequired,
//   closeModal: PropTypes.func.isRequired,
// };

export default UserFilterPopup;
